import React from 'react';
import './Aboutu.css'
import code from './Hand coding-bro.png'
const Aboutu = () => {
    return (
        <div className='aboutu' id='About'>
            <div className='abou2'>
                <h2>About Me</h2>
                <span>My Introduction</span>
            </div>
           
            <div className='content'>
                <div className='lefo'>
                <img className='code' alt='' src={code}/>
                </div>
            <div className='righto'>
                <div className='clobar'>
                    <span className='span1'></span>
                    <span className='span2'></span>
                    <span className='span3'></span>
                </div>
                <hr></hr>
            <p className='p'>
              Hello, I'm a Frontend Web Developer building the Front-end of Websites responsively. Check out some of my work in the Projects section. I'm open to Job opportunities where I can contribute, learn and grow. If you have a good opportunity that matches my skills then don't hesitate to contact me.
            </p>
            <div>
            <a target='_blank' href={'https://docs.google.com/document/d/1Zh11QfkB1Z9S7Ru59hew52YKhhrCQ6kmL8yXwSHySEY/edit?usp=sharing'} 
            className='Cvbutton'>
             Download CV <img className='cv' src={'https://cdn-icons-png.flaticon.com/512/1736/1736664.png'}/></a>
            </div>
            </div>
            
            </div>
           
        </div>
    );
};

export default Aboutu;